import "core-js/modules/es.array.push.js";
import httpRequest from '@/request/index';
import { ref, onMounted } from 'vue';
import { useStore } from 'vuex';
import { showToast, showFailToast, showLoadingToast, closeToast } from 'vant';
import { useRouter } from "vue-router";
export default {
  setup() {
    const store = useStore();
    const router = useRouter();
    const formData = ref({
      old_pwd: "",
      user_pwd: "",
      user_pwd2: ""
    });
    function saveInfo() {
      if (formData.value.old_pwd == "") {
        showFailToast("旧密码不能为空");
        return false;
      }
      if (formData.value.user_pwd == "") {
        showFailToast("旧密码不能为空");
        return false;
      }
      if (formData.value.user_pwd2 == "") {
        showFailToast("确认密码不能为空");
        return false;
      }
      if (formData.value.user_pwd != formData.value.user_pwd2) {
        showFailToast("确认密码错误");
        return false;
      }
      showLoadingToast({
        message: '保存中',
        forbidClick: true
      });
      httpRequest({
        method: "post",
        url: "?file=user&act=pwd",
        data: formData.value
      }).then(res => {
        closeToast();
        console.log(res);
        if (res.state == 1) {
          showToast({
            message: "修改成功",
            onClose: function () {
              router.push("/user");
            }
          });
        } else {
          showFailToast(res.msg);
        }
      });
    }
    onMounted(async () => {
      await store.dispatch("cklogin").then(() => {
        if (!store.state.isLogin) {
          router.replace("/login");
        }
      });
    });
    const goBack = () => {
      router.go(-1);
    };
    return {
      formData,
      saveInfo,
      goBack
    };
  }
};